module.exports = __webpack_public_path__ + "img/Secure-SSL-white.edaecc01.svg";